import ExperiencesPassportOfferSummary from 'components/Experiences/ExperiencesPassport/ExperiencesPassportOfferSummary'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LuxPlusInclusions from 'luxPlus/components/LuxPlusInclusions'
import TasteOfGoldTileBenefitMessage from 'takeovers/tasteOfGoldTakeover/components/TasteOfGoldTileBenefitMessage'
import type { SvgIconProps } from 'LuxKit/SvgIcon'
import InclusionsSection from './InclusionsSection'

interface Props {
  offer?: App.HotelOffer
  inclusions: Array<App.PackageInclusion>
  bonusInclusions: Array<App.PackageInclusion>
  luxPlusInclusions: Array<App.PackageInclusion>
  rooms?: Array<App.Occupants>
  showReturnFlightsInclusion?: boolean
  showTasteOfGoldBenefit?: boolean
  size?: 'small' | 'medium' | 'large'
  iconSize?: SvgIconProps['size']
}

function FlashHotelRateInclusionsContent({
  offer,
  inclusions,
  bonusInclusions,
  luxPlusInclusions,
  rooms,
  showReturnFlightsInclusion,
  showTasteOfGoldBenefit,
  size,
  iconSize,
}: Props) {
  return <VerticalSpacer gap={8}>
    {!!luxPlusInclusions.length && (
      <LuxPlusInclusions
        luxPlusInclusions={luxPlusInclusions}
        accommodationOffer={offer}
        hideUpsellModal
        size={size}
        iconSize={iconSize}
      />
    )}
    {showTasteOfGoldBenefit && <TasteOfGoldTileBenefitMessage />}
    <InclusionsSection
      offer={offer}
      inclusions={inclusions}
      bonusInclusions={bonusInclusions}
      showReturnFlightsInclusion={showReturnFlightsInclusion}
      rooms={rooms}
      size={size}
      iconSize={iconSize}
    />
    <ExperiencesPassportOfferSummary />
  </VerticalSpacer>
}

export default FlashHotelRateInclusionsContent
